import { render, staticRenderFns } from "./RevisarChapuzon2026.vue?vue&type=template&id=1e7d2d7b&scoped=true&"
import script from "./RevisarChapuzon2026.vue?vue&type=script&lang=ts&"
export * from "./RevisarChapuzon2026.vue?vue&type=script&lang=ts&"
import style0 from "./RevisarChapuzon2026.vue?vue&type=style&index=0&id=1e7d2d7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7d2d7b",
  null
  
)

export default component.exports